import { createAction, props } from '@ngrx/store';

import {
  PatientEstimateVerifyRequest,
  PatientEstimateVerifyResponse,
} from '@patient-ui/shared/models';

export const VerifyPatientEstimate = createAction(
  '[PatientEstimate] Verify Patient Estimate',
  props<{ payload: PatientEstimateVerifyRequest }>()
);

export const VerifyPatientEstimateSuccess = createAction(
  '[PatientEstimate] Verify Patient Estimate Success',
  props<{ response: PatientEstimateVerifyResponse }>()
);

export const VerifyPatientEstimateFailure = createAction(
  '[PatientEstimate] Verify Patient Estimate Failure',
  props<{ error: { status: number; message: string } }>()
);

export const ClearPatientEstimateState = createAction(
  '[PatientEstimate] Clear Patient Estimate State'
);

export const PatientEstimateActions = {
  VerifyPatientEstimate,
  VerifyPatientEstimateSuccess,
  VerifyPatientEstimateFailure,
  ClearPatientEstimateState,
};
